import React from 'react';
import { numberFormat, replaceVal } from '../../../utils/formatting';
import { __ } from '../../../utils/translation-service';
import { Size } from '../discount/discount';
import { RatingBig } from './rating-big/rating-big';
import {
    StyledAmount,
    StyledArrow,
    StyledRatingString,
    StyledRatingStringBox,
    StyledRatingValueBox,
    StyledRatingWrapper,
} from './rating.style';

interface IRating {
    value: number;
    base?: number;
    string: string;
    amount: number;
    size?: Size;
}

export const Rating = ({ value, base = 10, string, amount = 0, size = 'S' }: IRating) => {
    if (!value) return null;
    return size === 'L' ? (
        <RatingBig string={string} value={value} amount={amount} />
    ) : (
        <StyledRatingWrapper data-testid={'rating-component'}>
            <StyledRatingValueBox size={size}>
                {value}/{base}
            </StyledRatingValueBox>
            <StyledArrow />
            <StyledRatingStringBox>
                <StyledRatingString>{string}</StyledRatingString>
                <StyledAmount>
                    {amount && amount > 0
                        ? replaceVal(
                              __('reviews'),
                              numberFormat(amount, { maxDecimals: 1 }),
                              /\[amount]/g,
                          )
                        : null}
                </StyledAmount>
            </StyledRatingStringBox>
        </StyledRatingWrapper>
    );
};
